import { ref, onMounted } from 'vue'

export default {
    name: 'StickySliderElement',
    setup() {
        const imgTopPosSticky = ref('40px')
        const imgTopPosStickyInt = ref(40)

        const setImgTopPosSticky = (stickySliderElement) => {
            imgTopPosSticky.value =
                window.getComputedStyle(stickySliderElement).top
            imgTopPosStickyInt.value = parseFloat(
                imgTopPosSticky.value.replace('px', '')
            )
        }

        const getNextElement = (currentElement) => {
            const containers = document.querySelectorAll(
                '.kb-js--content-container'
            )
            const currentIndex = Array.from(containers).indexOf(currentElement)
            if (currentIndex >= 0 && currentIndex < containers.length - 1) {
                return containers[currentIndex + 1]
            }
            return currentElement
        }

        const changeBackgroundColor = (elm) => {
            const parentContainer = elm.closest('.kb-sticky-slider-element')
            const parentClasses = parentContainer.classList
            parentClasses.forEach((item) => {
                if (item.includes('kb-colortheme')) {
                    parentContainer.classList.remove(item)
                }
            })

            if (elm.dataset.theme) {
                parentContainer.classList.add(elm.dataset.theme)
            }
        }

        const changeImage = (elm) => {
            const imageContainers = document.querySelectorAll(
                '.kb-js--sticky-slider-image-container'
            )
            const imageContainer = elm.querySelector(
                '.kb-js--sticky-slider-image-container'
            )
            imageContainers.forEach((container) =>
                container.classList.remove(
                    'kb-sticky-slider-element__left-container--shown'
                )
            )
            imageContainer.classList.add(
                'kb-sticky-slider-element__left-container--shown'
            )
        }

        const handleIntersection = (entries) => {
            entries.forEach((entry) => {
                if (
                    entry.isIntersecting &&
                    imgTopPosStickyInt.value &&
                    entry.intersectionRect.top <= imgTopPosStickyInt.value
                ) {
                    if (!entry.target) return
                    changeBackgroundColor(entry.target)
                    changeImage(entry.target)
                } else if (
                    !entry.isIntersecting &&
                    entry.boundingClientRect.top < 0
                ) {
                    const nextElement = getNextElement(entry.target)
                    if (!nextElement) return
                    changeBackgroundColor(nextElement)
                    changeImage(nextElement)
                }
            })
        }

        // Ensures the section is at least as tall as the sticky image,
        // so text-shorter-than-image sections don't clip the image.
        const handleResize = (entries) => {
            entries.forEach((entry) => {
                const contentWrapper = entry.target.closest(
                    '.kb-js--content-container'
                )
                const textContentHeight = entry.contentRect.height
                const imgHeight = contentWrapper
                    .querySelector('.kb-js--sticky-slider-element')
                    .getBoundingClientRect().height
                if (contentWrapper && textContentHeight) {
                    if (imgHeight > textContentHeight) {
                        contentWrapper.style.height = `${imgHeight}px`
                    } else {
                        contentWrapper.style.height = `${textContentHeight}px`
                    }
                }
            })
        }

        onMounted(() => {
            const contentContainers = document.querySelectorAll(
                '.kb-sticky-slider-element__content-container'
            )

            const stickySliderElement = document.querySelector(
                '.kb-js--sticky-slider-element'
            )
            if (stickySliderElement) {
                setImgTopPosSticky(stickySliderElement)
            }

            const observer = new IntersectionObserver(handleIntersection, {
                rootMargin: `-${imgTopPosSticky.value}`
            })
            contentContainers.forEach((stickyElm) => observer.observe(stickyElm))

            const resizeObserver = new ResizeObserver(handleResize)
            contentContainers.forEach((stickyElm) => {
                const containerRight = stickyElm.querySelector(
                    '.kb-js--sticky-container-right'
                )
                const textContentArea = containerRight.children[0]
                resizeObserver.observe(
                    textContentArea ? textContentArea : containerRight
                )
            })
        })
    }
}
